import React from 'react';

const LBEcommerceApp = () => {
  return (
    <div style={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
      <iframe
        src="/projectList/lb-ecommerce.html"
        title="Little brahma E-comerce App"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
     
    </div>
    
  );
}

export default LBEcommerceApp;